export const parent = {
  animate: {
    transition: {
      staggerChildren: 0.1,
    },
  },
};

export const contentSlideUp = {
  initial: {
    opacity: 0,
    y: 100,
  },
  animate: {
    opacity: 1,
    y: 0,
  },
};

export const contentSlideRight = {
  initial: {
    opacity: 0,
    x: 20,
  },
  animate: {
    opacity: 1,
    x: 0,
  },
};

export const transition = {
  duration: 0.8,
  ease: [0.6, -0.5, 0.01, 0.9],
};

export const backButton = {
  initial: {
    opacity: 0,
    x: -50,
  },
  animate: {
    opacity: 1,
    x: 0,
  },
};

export const transitionBackButton = {
  duration: 0.8,
  delay: 0.5,
  ease: [0.6, -0.5, 0.01, 0.9],
};

// ZONE ANIM SPECIFIQUE
//Specifique a [membre].tsx
export const parentSocials = {
  animate: {
    transition: {
      staggerChildren: 0.25,
    },
  },
};

export const titleSlideUp = {
  initial: {
    opacity: 0,
    y: 100,
  },
  animate: {
    opacity: 1,
    y: 0,
  },
};
